module.exports = __webpack_public_path__ + "static/media/Ellipse524.6423ff58.svg";